module.exports = __webpack_public_path__ + "media/images/ln/constellation_08-7fd5c234bc31fa8c5743d663130a4805.png";